import React from "react";
import { ReferenceInput, required, SelectInput } from "react-admin";

interface ICustomCcaAcademicYearInput {
  parentCallback?: (x: number) => void;
  schoolId: string;
  isDisabled?: boolean;
  isRequired?: boolean;
}

const CustomCcaAcademicYearInput = ({
  parentCallback,
  schoolId,
  isDisabled,
  isRequired,
}: ICustomCcaAcademicYearInput) => {
  return (
    <ReferenceInput
      label="CCA Academic Year"
      source="ccaAcademicYearId"
      reference="ccaAcademicYears"
      filter={{ SchoolId: schoolId ? Number(schoolId) : 0 }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectInput optionText="name" optionId="id" />
    </ReferenceInput>
  );
};

export default CustomCcaAcademicYearInput;
